import { LocationSelectOption } from '../../components/LocationSelect';
import { trimCommas } from '../../components/LocationSelect/helpers';
import {
    PublicBlendedCourse,
    PublicClassCourse,
    PublicOccurrence,
} from '@cademy-package/sdk-component-types';

export const getFilteredOccurrences = (
    filter: LocationSelectOption | null,
    occurrences: Array<PublicOccurrence>,
    course: PublicClassCourse | PublicBlendedCourse
) => {
    if (!filter) return occurrences;
    const filteredOcc = [...occurrences].filter((occ) => {
        if (filter.key === 'none') return true;

        if (filter.key === 'delivery' && filter.value === 'online') {
            // covers cases where delivery doesn't exist
            if (!occ.delivery && course.delivery === 'online') return true;
            if (!occ.delivery) return false;

            if (['online', 'hybrid'].includes(occ.delivery)) return true;
        }
        if (filter.key === 'address') {
            // Escape early if the delivery is online for this occurrence
            if (occ.delivery && occ.delivery === 'online') return false;
            if (occ.address) {
                // If filter has 'street' on it, we need to filter occurrences by street and city
                if (filter.address.street) {
                    if (
                        trimCommas(occ.address.city).toLowerCase() ===
                            filter.address.city.toLowerCase() &&
                        trimCommas(occ.address.street).toLowerCase() ===
                            filter.address.street.toLowerCase()
                    ) {
                        return true;
                    }
                } else {
                    // else just filtering occ from the same city is OK
                    if (trimCommas(occ.address.city) === filter.address.city) {
                        return true;
                    }
                }
            } else {
                if (filter.address.street) {
                    if (
                        course.address?.city === filter.address.city &&
                        course.address?.street === filter.address.street
                    ) {
                        return true;
                    }
                } else {
                    if (course.address?.city === filter.address.city) {
                        return true;
                    }
                }
            }
        }
        return false;
    });
    return filteredOcc;
};
